<div>
  <div class="sm:flex sm:items-center mb-6">
    <div class="sm:flex-auto">
      <h1 class="text-xl font-semibold text-gray-900">Send Money</h1>
    </div>
  </div>

  <div class="bg-white shadow-md rounded-lg p-6 max-w-lg mx-auto">
    <form (ngSubmit)="sendMoney()" #sendMoneyForm="ngForm" class="space-y-5">

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="text-sm text-red-500 bg-red-50 border border-red-200 rounded p-2">
        {{ errorMessage }}
      </div>

      <!-- Recipient Type -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Recipient Type</label>
        <select
          [(ngModel)]="recipientType"
          name="recipientType"
          class="block w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-indigo-500 focus:border-indigo-500"
        >
          <option value="bank">Bank Recipient</option>
          <option value="crypto">Crypto Recipient</option>
        </select>
      </div>

      <!-- Recipient -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">
          {{ recipientType === 'bank' ? 'Bank Recipient' : 'Crypto Recipient' }}
        </label>

        <select
          name="recipient"
          [(ngModel)]="selectedRecipient"
          #recipient="ngModel"
          required
          class="block w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-indigo-500 focus:border-indigo-500"
          [ngClass]="{'border-red-500': recipient.invalid && recipient.touched}"
        >
          <option value="" disabled selected>Select recipient</option>
          <ng-container *ngIf="recipientType === 'bank'; else cryptoList">
            <option *ngFor="let r of bankRecipients" [value]="r.uuid">
              {{ r.first_name }} {{ r.last_name }} — {{ r.iban }}
            </option>
          </ng-container>

          <ng-template #cryptoList>
            <option *ngFor="let r of cryptoRecipients" [value]="r.uuid">
              {{ r.name || 'Unnamed Wallet' }} — {{ r.address }}
            </option>
          </ng-template>
        </select>

        <p *ngIf="recipient.invalid && recipient.touched" class="text-xs text-red-500 mt-1">
          Please select a recipient.
        </p>
      </div>

      <!-- Amount -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Amount (USD)</label>
        <input
          type="number"
          name="amount"
          [(ngModel)]="amount"
          #amountField="ngModel"
          required
          min="0.01"
          step="0.01"
          class="block w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-indigo-500 focus:border-indigo-500"
          [ngClass]="{'border-red-500': amountField.invalid && amountField.touched}"
        />
        <p *ngIf="amountField.invalid && amountField.touched" class="text-xs text-red-500 mt-1">
          Amount must be greater than 0.
        </p>
      </div>

      <!-- Note -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-1">Note (optional)</label>
        <textarea
          name="note"
          [(ngModel)]="note"
          rows="3"
          placeholder="Add a note to this transfer"
          class="block w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-indigo-500 focus:border-indigo-500"
        ></textarea>
      </div>

      <!-- Actions -->
      <div class="flex justify-end mt-6">
        <button
          type="submit"
          [disabled]="sendMoneyForm.invalid || sending"
          class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-md shadow-sm hover:bg-indigo-500 disabled:opacity-50"
        >
          <svg
            *ngIf="sending"
            class="animate-spin h-4 w-4 mr-2 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4z"
            ></path>
          </svg>
          <span>{{ sending ? 'Sending...' : 'Send' }}</span>
        </button>
      </div>
    </form>
  </div>
</div>
